import FontIcon from 'components/icons/FontIcon';
import { TextButton } from 'components/v2/buttons';
import TitleAndBack from 'components/v2/TitleAndBack';
import { useHistory } from 'react-router-dom';
import { EpdLinks } from 'routes/EpdRoutes';
import { Container } from 'styles/Styles.styled';
import { WizardHeaderGrid } from 'styles/v2/Styles.styled';

interface CompareLayoutProps {
  fullWidth: boolean;
  setFullWidth: React.Dispatch<React.SetStateAction<boolean>>;
  epdId: string;
  children: React.ReactNode;
}

const CompareLayout: React.FC<CompareLayoutProps> = ({ fullWidth, setFullWidth, epdId, children }) => {
  const history = useHistory();

  return (
    <Container $fullWidth={fullWidth}>
      <WizardHeaderGrid>
        <TitleAndBack
          title="EPD Version comparison"
          backTo="Back to the EPD"
          onBack={() => history.push(EpdLinks.epd(epdId))}
        />
        <div>
          <TextButton
            className="white-space-nowrap"
            style={{ cursor: 'pointer' }}
            tooltip={fullWidth ? 'Condense view' : 'Expand view'}
            tooltipOptions={{ position: 'left' }}
            icon={<FontIcon icon="expand" />}
            text
            onClick={() => setFullWidth((v) => !v)}
          />
        </div>
      </WizardHeaderGrid>

      {children}
    </Container>
  );
};

export default CompareLayout;
